<template>
  <div class="setting-join-websiteWrap">
    <ul class="setting-join-website-tab-container module-item-style" >
<!--      v-if="tabbar.length > 0"-->
      <router-link :to="menu.path" tag="li" v-for="(menu, index) in tabbar" :class="$route.path == menu.path ? 'tabActived' : ''" :key="index">{{menu.meta.title}}</router-link>
    </ul>
    <div class="setting-join-website-content-container module-item-style" :class="$route.path != 'setting-join-website' ? 'mobOrPic' : ''">
      <transition name="fade-transform" mode="out-in">
        <router-view/>
      </transition>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'setting-join-website',
    data() {
      return {
        imageUrl: '',


      }
    },
	watch: {
		$route(to, from) {
		  console.log('change')
		  document.body.scrollIntoView()
		}
	},
    computed:{
      tabbar(){
        let menu = []
        let currenMenuMatched = this.$route.matched
        this.$store.state.permission.addRoutes.map((item) => {
          if(item.name == 'layout'){
            item.children.map( subItem => {
              if(subItem.path == currenMenuMatched[1].path){
                subItem.children.map( subSubItem => {
                  if(subSubItem.path == currenMenuMatched[2].path){
                    subSubItem.children.map( subSunSubItem => {
                      if(subSunSubItem.path == currenMenuMatched[3].path){
                        menu = subSunSubItem.children
                      }
                    })
                  }
                })
              }
            })
          }
        })
        return menu
      }
    },
    mounted() {

    },
    methods: {

    }
  }
</script>

<style lang="scss">
  @import "./css/join.scss";
  .setting-join-websiteWrap {
	  padding-top: 40px;
	 .module-item-style.mobOrPic{
		 background: initial;
	 }
    .setting-join-website-tab-container {
      display: flex;
      padding: 24px 24px 17px;
	  width: 100%;
	  position: fixed;
	  top: 100px;
	  z-index: 9;
      li {
        margin-right: 40px;
        color: #333333;
        font-size: 12px;
        letter-spacing: 1.4px;
        cursor: pointer;
        padding-bottom: 7px;
      }
    }

    .setting-join-website-content-container {
      margin-top: 10px;
      padding: 22px;
    }
  }
</style>
